import React from 'react';

// A pill with a little check circle. Off: hairline + empty ring. On: brighter
// text, the ring fills green with a tick. Used for one-tap answers.
const TogglePill = ({ on, children, className = '', ...props }) => (
  <button
    type="button"
    aria-pressed={!!on}
    className={`inline-flex items-center gap-2 rounded-full border bg-transparent py-2 pl-3 pr-4 text-base font-medium transition-colors disabled:opacity-50 ${
      on ? 'border-fg-3 text-fg' : 'border-line-strong text-fg-2 hover:text-fg hover:border-fg-3'
    } ${className}`}
    {...props}
  >
    <span
      className={`inline-grid h-4 w-4 place-items-center rounded-full border-[1.5px] ${
        on ? 'border-good-strong bg-good-strong dark:border-good dark:bg-good' : 'border-fg-3'
      }`}
      aria-hidden="true"
    >
      {on && <span className="mb-px h-2 w-[5px] rotate-45 border-b-2 border-r-2 border-white" />}
    </span>
    {children}
  </button>
);

export default TogglePill;
